import { useState, useEffect } from "react";

const statusColor = { "Now Selling": "#c9a96e", "Pre-Launch": "#8a9a7a", "Sold Out": "#555" };

function PropertyModal({ dev, onClose, onEnquire }) {
  const [activeImg, setActiveImg] = useState(0);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  useEffect(() => {
    const handler = (e) => { if (e.key === "Escape") handleClose(); };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  const handleClose = () => {
    setClosing(true);
    setTimeout(onClose, 300);
  };

  return (
    <div style={{ ...ms.backdrop, opacity: closing ? 0 : 1 }} onClick={(e) => e.target === e.currentTarget && handleClose()}>
      <div style={{ ...ms.modal, transform: closing ? "translateY(40px)" : "translateY(0)", opacity: closing ? 0 : 1 }}>
        <button style={ms.closeBtn} onClick={handleClose}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M18 6L6 18M6 6l12 12"/></svg>
        </button>
        <div style={ms.inner} className="modal-inner">
          <div style={ms.imgCol}>
            <div style={ms.mainImgWrap}>
              <img src={dev.images[activeImg]} alt={dev.name} style={ms.mainImg} key={activeImg} className="modal-img-fade" />
              <div style={ms.imgOverlay} />
              <span style={{ ...ms.badge, background: statusColor[dev.status] || "#c9a96e" }}>{dev.status}</span>
              {activeImg > 0 && <button style={{ ...ms.arrow, left: 16 }} onClick={() => setActiveImg(i => i - 1)}>‹</button>}
              {activeImg < dev.images.length - 1 && <button style={{ ...ms.arrow, right: 16 }} onClick={() => setActiveImg(i => i + 1)}>›</button>}
              <div style={ms.imgCounter}>{activeImg + 1} / {dev.images.length}</div>
            </div>
            <div style={ms.thumbRow}>
              {dev.images.map((img, i) => (
                <div key={i} style={{ ...ms.thumb, outline: activeImg === i ? "2px solid #c9a96e" : "2px solid transparent", outlineOffset: -2 }} onClick={() => setActiveImg(i)}>
                  <img src={img} alt="" style={ms.thumbImg} />
                </div>
              ))}
            </div>
          </div>
          <div style={ms.infoCol}>
            <p style={ms.infoEyebrow}>{dev.type} · {dev.location}</p>
            <h2 style={ms.infoTitle}>{dev.name}</h2>
            <p style={ms.infoPrice}>{dev.price}</p>
            <div style={ms.divider} />
            <div style={ms.specsRow}>
              {[["🛏", dev.beds], ["🚿", dev.baths], ["📐", dev.size], ["🗓", dev.completion]].map(([icon, val]) => (
                <div key={val} style={ms.spec}><span style={ms.specIcon}>{icon}</span><span style={ms.specVal}>{val}</span></div>
              ))}
            </div>
            <div style={ms.divider} />
            <p style={ms.description}>{dev.description}</p>
            <div style={ms.divider} />
            <p style={ms.featuresTitle}>FEATURES & AMENITIES</p>
            <div style={ms.featuresGrid}>
              {dev.features.map((f) => (
                <div key={f} style={ms.featureItem}><span style={ms.featureDot} />{f}</div>
              ))}
            </div>
            <button style={ms.enquireBtn} onClick={() => { handleClose(); setTimeout(onEnquire, 350); }}>ENQUIRE ABOUT THIS PROPERTY</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const [developments, setDevelopments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeCard, setActiveCard] = useState(null);
  const [selectedDev, setSelectedDev] = useState(null);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    fetch("/developments.json")
      .then(r => r.json())
      .then(data => { setDevelopments(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSubmit = (e) => {
  e.preventDefault();

  const data = new FormData();
  data.append("form-name", "contact");
  data.append("name",    formData.name);
  data.append("email",   formData.email);
  data.append("phone",   formData.phone);
  data.append("message", formData.message);

  fetch("/", { method: "POST", body: data })
    .then(() => setSubmitted(true))
    .catch(() => alert("Something went wrong, please try again."));
};
  const scrollTo = (id) => { document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }); setMenuOpen(false); };

  return (
    <div style={styles.root}>
      <style>{css}</style>

      {selectedDev && <PropertyModal dev={selectedDev} onClose={() => setSelectedDev(null)} onEnquire={() => scrollTo("contact")} />}

      {/* NAV */}
      <nav style={{ ...styles.nav, background: scrollY > 60 ? "rgba(8,8,8,0.97)" : "transparent" }}>
        <div style={styles.navInner}>
          <div style={styles.logo}><span style={styles.logoMain}>EMPIRE</span><span style={styles.logoYear}>2025</span></div>
          <div style={styles.navLinks}>
            {["developments", "about", "contact"].map((s) => (
              <button key={s} style={styles.navLink} onClick={() => scrollTo(s)}>{s.toUpperCase()}</button>
            ))}
          </div>
          <button style={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)}>
            <span style={{ ...styles.bar, transform: menuOpen ? "rotate(45deg) translate(5px,5px)" : "none" }} />
            <span style={{ ...styles.bar, opacity: menuOpen ? 0 : 1 }} />
            <span style={{ ...styles.bar, transform: menuOpen ? "rotate(-45deg) translate(5px,-5px)" : "none" }} />
          </button>
        </div>
        {menuOpen && (
          <div style={styles.mobileMenu}>
            {["developments", "about", "contact"].map((s) => (
              <button key={s} style={styles.mobileLink} onClick={() => scrollTo(s)}>{s.toUpperCase()}</button>
            ))}
          </div>
        )}
      </nav>

      {/* HERO */}
      <section style={styles.hero}>
        <div style={{ ...styles.heroBg, transform: `translateY(${scrollY * 0.3}px)` }} />
        <div style={styles.heroOverlay} />
        <div style={styles.heroContent} className="fade-in">
          <p style={styles.heroEyebrow}>PREMIUM REAL ESTATE</p>
          <h1 style={styles.heroTitle}>Where Vision<br />Meets Value</h1>
          <p style={styles.heroSub}>Curated developments across the finest locations on the Costa del Sol.</p>
          <div style={styles.heroCta}>
            <button style={styles.btnPrimary} onClick={() => scrollTo("developments")}>EXPLORE DEVELOPMENTS</button>
            <button style={styles.btnGhost} onClick={() => scrollTo("contact")}>GET IN TOUCH</button>
          </div>
        </div>
        <div style={styles.heroScroll}>
          <div className="scroll-dot" style={styles.scrollDot} />
          <span style={styles.scrollText}>SCROLL</span>
        </div>
      </section>

      {/* STATS */}
      <section style={styles.stats}>
        {[["10+", "Developments"], ["€2B+", "Portfolio Value"], ["500+", "Units Sold"], ["15", "Years Experience"]].map(([n, l]) => (
          <div key={l} style={styles.statItem}><span style={styles.statNum}>{n}</span><span style={styles.statLabel}>{l}</span></div>
        ))}
      </section>

      {/* DEVELOPMENTS */}
      <section id="developments" style={styles.section}>
        <div style={styles.sectionHeader}>
          <p style={styles.eyebrow}>OUR PORTFOLIO</p>
          <h2 style={styles.sectionTitle}>Current Developments</h2>
          <div style={styles.titleLine} />
          <p style={{ color: "#555", fontSize: 13, marginTop: 18, fontFamily: "'Montserrat', sans-serif", letterSpacing: "0.08em" }}>CLICK ANY PROPERTY TO VIEW DETAILS</p>
        </div>
        {loading ? (
          <div style={{ textAlign: "center", padding: "60px 0", color: "#555", fontFamily: "'Montserrat', sans-serif", letterSpacing: "0.2em", fontSize: 12 }}>LOADING...</div>
        ) : (
          <div style={styles.grid}>
            {developments.map((d, i) => (
              <div key={d.id} style={{ ...styles.card, animationDelay: `${i * 0.07}s` }} className="card"
                onMouseEnter={() => setActiveCard(d.id)} onMouseLeave={() => setActiveCard(null)} onClick={() => setSelectedDev(d)}>
                <div style={styles.cardImgWrap}>
                  <img src={d.images[0]} alt={d.name} style={{ ...styles.cardImg, transform: activeCard === d.id ? "scale(1.07)" : "scale(1)" }} />
                  <div style={styles.cardOverlay} />
                  <span style={{ ...styles.statusBadge, background: statusColor[d.status] || "#c9a96e" }}>{d.status}</span>
                  <div style={{ ...styles.viewMore, opacity: activeCard === d.id ? 1 : 0 }}>VIEW DETAILS</div>
                </div>
                <div style={styles.cardBody}>
                  <p style={styles.cardType}>{d.type} · {d.units}</p>
                  <h3 style={styles.cardName}>{d.name}</h3>
                  <p style={styles.cardLocation}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#c9a96e" strokeWidth="2" style={{ marginRight: 5 }}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>
                    {d.location}
                  </p>
                  <div style={styles.cardFooter}>
                    <span style={styles.cardPrice}>{d.price}</span>
                    <button style={styles.cardBtn} onClick={(e) => { e.stopPropagation(); setSelectedDev(d); }}>VIEW →</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* ABOUT */}
      <section id="about" style={styles.aboutSection}>
        <div style={styles.aboutGrid} className="aboutGrid">
          <div style={styles.aboutImg}>
            <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80" alt="Office" style={styles.aboutPhoto} />
            <div style={styles.aboutImgAccent} />
          </div>
          <div>
            <p style={styles.eyebrow}>ABOUT EMPIRE 2025</p>
            <h2 style={styles.sectionTitle}>A Legacy Built on Excellence</h2>
            <div style={styles.titleLine} />
            <p style={styles.aboutPara}>Empire 2025 is a premier real estate agency dedicated to connecting discerning clients with exceptional properties across the Costa del Sol. With over 15 years of market expertise, we offer an unrivalled portfolio of luxury developments.</p>
            <p style={styles.aboutPara}>Our philosophy is simple: every client deserves white-glove service, transparent guidance, and access to the most coveted addresses in the region.</p>
            <div style={styles.aboutFeatures}>
              {["Exclusive Off-Market Access", "Bilingual Advisory Team", "End-to-End Transaction Support", "Post-Sale Property Management"].map((f) => (
                <div key={f} style={styles.feature}><span style={styles.featureDot} />{f}</div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" style={styles.section}>
        <div style={styles.sectionHeader}>
          <p style={styles.eyebrow}>LET'S TALK</p>
          <h2 style={styles.sectionTitle}>Contact Us</h2>
          <div style={styles.titleLine} />
        </div>
        <div style={styles.contactGrid} className="contactGrid">
          <div>
            <h3 style={styles.contactInfoTitle}>Get in Touch</h3>
            <p style={styles.contactInfoSub}>Our advisors are available to assist you in finding the perfect property. Reach out and we'll respond within 24 hours.</p>
            {[["📍","Calle Cipreses 20, Mijas, Spain"],["📞","+34 658372004"],["✉️","lana@empire2025.com"],["🕐","Mon–Sat: 9:00 – 19:00"]].map(([icon, text]) => (
              <div key={text} style={styles.contactRow}><span style={styles.contactIcon}>{icon}</span><span style={styles.contactRowText}>{text}</span></div>
            ))}
          </div>
          <div style={styles.formWrap}>
            {submitted ? (
              <div style={styles.thankYou}>
                <div style={styles.thankYouIcon}>✓</div>
                <h3 style={styles.thankYouTitle}>Message Received</h3>
                <p style={styles.thankYouSub}>Thank you for reaching out. A member of our team will contact you shortly.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} name="contact" netlify style={styles.form}>
                <input type="hidden" name="form-name" value="contact" />
                <div style={styles.formGroup}>
                  <label style={styles.label}>Full Name</label>
                  <input required name="name" type="text" placeholder="Your full name" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} style={styles.input} className="form-input" />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Email Address</label>
                  <input required name="email" type="email" placeholder="your@email.com" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} style={styles.input} className="form-input" />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Phone Number</label>
                  <input required name="phone" type="tel" placeholder="+34 000 000 000" value={formData.phone} onChange={(e) => setFormData({ ...formData, phone: e.target.value })} style={styles.input} className="form-input" />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Message</label>
                  <textarea required name="message" placeholder="Tell us about your property interests..." rows={4} value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} style={{ ...styles.input, resize: "vertical" }} className="form-input" />
                </div>
                <button type="submit" style={styles.btnPrimary}>SEND MESSAGE</button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={styles.footer}>
        <div style={styles.footerInner}>
          <div style={styles.logo}><span style={styles.logoMain}>EMPIRE</span><span style={styles.logoYear}>2025</span></div>
          <p style={styles.footerText}>© 2025 Empire 2025 Real Estate. All rights reserved.</p>
          <p style={styles.footerText}>Premium Real Estate · Costa del Sol, Spain</p>
        </div>
      </footer>
    </div>
  );
}

const ms = {
  backdrop: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.88)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px", transition: "opacity 0.3s ease", backdropFilter: "blur(8px)" },
  modal: { background: "#0f0f0f", width: "100%", maxWidth: 1080, maxHeight: "90vh", overflow: "auto", position: "relative", transition: "all 0.3s ease", border: "1px solid rgba(201,169,110,0.15)" },
  closeBtn: { position: "absolute", top: 20, right: 20, background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", color: "#e8e0d4", width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", zIndex: 10, borderRadius: 2 },
  inner: { display: "grid", gridTemplateColumns: "1.1fr 1fr" },
  imgCol: {},
  mainImgWrap: { position: "relative", height: 400, overflow: "hidden" },
  mainImg: { width: "100%", height: "100%", objectFit: "cover", display: "block" },
  imgOverlay: { position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(8,8,8,0.4) 0%, transparent 60%)" },
  badge: { position: "absolute", top: 16, left: 16, color: "#080808", fontSize: 9, letterSpacing: "0.2em", fontFamily: "'Montserrat', sans-serif", fontWeight: 700, padding: "5px 12px" },
  arrow: { position: "absolute", top: "50%", transform: "translateY(-50%)", background: "rgba(0,0,0,0.65)", border: "none", color: "#e8e0d4", fontSize: 30, width: 46, height: 46, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" },
  imgCounter: { position: "absolute", bottom: 16, right: 16, fontSize: 11, color: "#a89880", fontFamily: "'Montserrat', sans-serif", letterSpacing: "0.1em" },
  thumbRow: { display: "flex", gap: 2, padding: "2px 0 0" },
  thumb: { flex: 1, height: 72, cursor: "pointer", overflow: "hidden" },
  thumbImg: { width: "100%", height: "100%", objectFit: "cover", display: "block" },
  infoCol: { padding: "36px 36px 44px", overflowY: "auto", maxHeight: "90vh" },
  infoEyebrow: { fontSize: 10, letterSpacing: "0.25em", color: "#c9a96e", fontFamily: "'Montserrat', sans-serif", marginBottom: 10 },
  infoTitle: { fontSize: 30, fontWeight: 300, color: "#f5f0e8", margin: "0 0 8px", fontFamily: "'Cormorant Garamond', serif", letterSpacing: "0.02em" },
  infoPrice: { fontSize: 20, color: "#c9a96e", fontFamily: "'Cormorant Garamond', serif" },
  divider: { borderTop: "1px solid rgba(232,224,212,0.08)", margin: "20px 0" },
  specsRow: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px 0" },
  spec: { display: "flex", alignItems: "center", gap: 10 },
  specIcon: { fontSize: 15 },
  specVal: { fontSize: 12, color: "#a89880", fontFamily: "'Montserrat', sans-serif", letterSpacing: "0.03em" },
  description: { fontSize: 14, lineHeight: 1.9, color: "#777", fontWeight: 300 },
  featuresTitle: { fontSize: 10, letterSpacing: "0.25em", color: "#555", fontFamily: "'Montserrat', sans-serif", marginBottom: 14 },
  featuresGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px 16px", marginBottom: 28 },
  featureItem: { display: "flex", alignItems: "center", gap: 10, fontSize: 12, color: "#a89880", fontFamily: "'Montserrat', sans-serif" },
  featureDot: { width: 4, height: 4, background: "#c9a96e", borderRadius: "50%", flexShrink: 0 },
  enquireBtn: { background: "#c9a96e", color: "#080808", border: "none", padding: "15px 28px", fontSize: 11, letterSpacing: "0.2em", cursor: "pointer", fontFamily: "'Montserrat', sans-serif", fontWeight: 600, width: "100%" },
};

const styles = {
  root: { fontFamily: "'Cormorant Garamond', Georgia, serif", background: "#080808", color: "#e8e0d4", margin: 0, overflowX: "hidden" },
  nav: { position: "fixed", top: 0, left: 0, right: 0, zIndex: 100, transition: "background 0.4s ease", borderBottom: "1px solid rgba(201,169,110,0.1)" },
  navInner: { maxWidth: 1280, margin: "0 auto", padding: "18px 40px", display: "flex", alignItems: "center", justifyContent: "space-between" },
  logo: { display: "flex", alignItems: "baseline", gap: 6, cursor: "default" },
  logoMain: { fontSize: 22, fontWeight: 700, letterSpacing: "0.25em", color: "#e8e0d4", fontFamily: "'Cormorant Garamond', serif" },
  logoYear: { fontSize: 13, letterSpacing: "0.2em", color: "#c9a96e" },
  navLinks: { display: "flex", gap: 36 },
  navLink: { background: "none", border: "none", color: "#a89880", fontSize: 11, letterSpacing: "0.2em", cursor: "pointer", fontFamily: "inherit", transition: "color 0.2s" },
  hamburger: { display: "none", background: "none", border: "none", cursor: "pointer", padding: 4, flexDirection: "column", gap: 5 },
  bar: { display: "block", width: 24, height: 1.5, background: "#e8e0d4", transition: "all 0.3s" },
  mobileMenu: { padding: "16px 40px 24px", display: "flex", flexDirection: "column", gap: 16 },
  mobileLink: { background: "none", border: "none", color: "#a89880", fontSize: 13, letterSpacing: "0.2em", cursor: "pointer", textAlign: "left", fontFamily: "inherit", padding: "4px 0" },
  hero: { position: "relative", height: "100vh", minHeight: 700, display: "flex", alignItems: "center", overflow: "hidden" },
  heroBg: { position: "absolute", inset: "-20%", backgroundImage: "url(https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=1600&q=80)", backgroundSize: "cover", backgroundPosition: "center" },
  heroOverlay: { position: "absolute", inset: 0, background: "linear-gradient(135deg, rgba(8,8,8,0.85) 0%, rgba(8,8,8,0.5) 60%, rgba(8,8,8,0.75) 100%)" },
  heroContent: { position: "relative", maxWidth: 1280, margin: "0 auto", padding: "0 40px", width: "100%" },
  heroEyebrow: { fontSize: 11, letterSpacing: "0.3em", color: "#c9a96e", marginBottom: 24, fontFamily: "'Montserrat', sans-serif", fontWeight: 400 },
  heroTitle: { fontSize: "clamp(52px, 8vw, 110px)", fontWeight: 300, lineHeight: 1.0, color: "#f5f0e8", margin: "0 0 28px" },
  heroSub: { fontSize: 18, fontWeight: 300, color: "#a89880", maxWidth: 480, lineHeight: 1.7, marginBottom: 48 },
  heroCta: { display: "flex", gap: 20, flexWrap: "wrap" },
  btnPrimary: { background: "#c9a96e", color: "#080808", border: "none", padding: "16px 40px", fontSize: 11, letterSpacing: "0.2em", cursor: "pointer", fontFamily: "'Montserrat', sans-serif", fontWeight: 600 },
  btnGhost: { background: "transparent", color: "#e8e0d4", border: "1px solid rgba(232,224,212,0.3)", padding: "16px 40px", fontSize: 11, letterSpacing: "0.2em", cursor: "pointer", fontFamily: "'Montserrat', sans-serif", fontWeight: 400 },
  heroScroll: { position: "absolute", bottom: 40, left: "50%", transform: "translateX(-50%)", display: "flex", flexDirection: "column", alignItems: "center", gap: 8 },
  scrollDot: { width: 6, height: 6, borderRadius: "50%", background: "#c9a96e" },
  scrollText: { fontSize: 10, letterSpacing: "0.25em", color: "#666", fontFamily: "'Montserrat', sans-serif" },
  stats: { background: "#0f0f0f", borderTop: "1px solid rgba(201,169,110,0.15)", borderBottom: "1px solid rgba(201,169,110,0.15)", display: "flex", justifyContent: "center", flexWrap: "wrap" },
  statItem: { padding: "40px 60px", display: "flex", flexDirection: "column", alignItems: "center", gap: 6, borderRight: "1px solid rgba(201,169,110,0.1)" },
  statNum: { fontSize: 40, fontWeight: 300, color: "#c9a96e", lineHeight: 1 },
  statLabel: { fontSize: 11, letterSpacing: "0.2em", color: "#666", fontFamily: "'Montserrat', sans-serif" },
  section: { maxWidth: 1280, margin: "0 auto", padding: "100px 40px" },
  sectionHeader: { textAlign: "center", marginBottom: 70 },
  eyebrow: { fontSize: 11, letterSpacing: "0.3em", color: "#c9a96e", marginBottom: 16, fontFamily: "'Montserrat', sans-serif", fontWeight: 400 },
  sectionTitle: { fontSize: "clamp(32px, 4vw, 52px)", fontWeight: 300, color: "#f5f0e8", margin: "0 0 20px" },
  titleLine: { width: 50, height: 1, background: "#c9a96e", margin: "0 auto" },
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 2 },
  card: { background: "#0f0f0f", overflow: "hidden", cursor: "pointer", animation: "fadeUp 0.6s ease both" },
  cardImgWrap: { position: "relative", overflow: "hidden", height: 240 },
  cardImg: { width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.6s ease" },
  cardOverlay: { position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(8,8,8,0.6) 0%, transparent 50%)" },
  statusBadge: { position: "absolute", top: 16, right: 16, color: "#080808", fontSize: 9, letterSpacing: "0.2em", fontFamily: "'Montserrat', sans-serif", fontWeight: 700, padding: "5px 12px" },
  viewMore: { position: "absolute", inset: 0, background: "rgba(8,8,8,0.5)", display: "flex", alignItems: "center", justifyContent: "center", transition: "opacity 0.3s", fontSize: 11, letterSpacing: "0.25em", color: "#c9a96e", fontFamily: "'Montserrat', sans-serif" },
  cardBody: { padding: "24px 24px 28px" },
  cardType: { fontSize: 11, letterSpacing: "0.15em", color: "#666", marginBottom: 8, fontFamily: "'Montserrat', sans-serif" },
  cardName: { fontSize: 22, fontWeight: 400, color: "#f5f0e8", margin: "0 0 10px" },
  cardLocation: { display: "flex", alignItems: "center", fontSize: 13, color: "#888", marginBottom: 20 },
  cardFooter: { display: "flex", justifyContent: "space-between", alignItems: "center" },
  cardPrice: { fontSize: 16, color: "#c9a96e" },
  cardBtn: { background: "none", border: "1px solid rgba(201,169,110,0.4)", color: "#c9a96e", padding: "8px 18px", fontSize: 10, letterSpacing: "0.2em", cursor: "pointer", fontFamily: "'Montserrat', sans-serif" },
  aboutSection: { background: "#0a0a0a", padding: "100px 40px" },
  aboutGrid: { maxWidth: 1280, margin: "0 auto", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 80, alignItems: "center" },
  aboutImg: { position: "relative" },
  aboutPhoto: { width: "100%", height: 520, objectFit: "cover", display: "block" },
  aboutImgAccent: { position: "absolute", bottom: -20, right: -20, width: "60%", height: "60%", border: "1px solid rgba(201,169,110,0.3)", zIndex: 0, pointerEvents: "none" },
  aboutPara: { fontSize: 16, lineHeight: 1.9, color: "#a89880", marginBottom: 20, fontWeight: 300 },
  aboutFeatures: { marginTop: 32, display: "flex", flexDirection: "column", gap: 14 },
  feature: { display: "flex", alignItems: "center", gap: 14, fontSize: 15, color: "#c8bfb0" },
  featureDot: { width: 5, height: 5, background: "#c9a96e", borderRadius: "50%", flexShrink: 0 },
  contactGrid: { display: "grid", gridTemplateColumns: "1fr 1.2fr", gap: 80 },
  contactInfoTitle: { fontSize: 28, fontWeight: 300, color: "#f5f0e8", margin: "0 0 16px" },
  contactInfoSub: { fontSize: 15, color: "#888", lineHeight: 1.8, marginBottom: 36, fontWeight: 300 },
  contactRow: { display: "flex", gap: 16, alignItems: "flex-start", marginBottom: 20 },
  contactIcon: { fontSize: 16, lineHeight: 1.6 },
  contactRowText: { fontSize: 15, color: "#a89880", lineHeight: 1.6 },
  formWrap: { background: "#0f0f0f", padding: "48px", border: "1px solid rgba(201,169,110,0.1)" },
  form: { display: "flex", flexDirection: "column", gap: 24 },
  formGroup: { display: "flex", flexDirection: "column", gap: 8 },
  label: { fontSize: 10, letterSpacing: "0.2em", color: "#666", fontFamily: "'Montserrat', sans-serif" },
  input: { background: "transparent", border: "none", borderBottom: "1px solid rgba(232,224,212,0.15)", color: "#e8e0d4", padding: "12px 0", fontSize: 15, fontFamily: "'Cormorant Garamond', Georgia, serif", outline: "none" },
  thankYou: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 300, textAlign: "center" },
  thankYouIcon: { width: 56, height: 56, borderRadius: "50%", border: "1px solid #c9a96e", display: "flex", alignItems: "center", justifyContent: "center", color: "#c9a96e", fontSize: 22, marginBottom: 24 },
  thankYouTitle: { fontSize: 28, fontWeight: 300, color: "#f5f0e8", margin: "0 0 12px" },
  thankYouSub: { fontSize: 15, color: "#888", lineHeight: 1.8, maxWidth: 300 },
  footer: { background: "#050505", borderTop: "1px solid rgba(201,169,110,0.1)", padding: "48px 40px" },
  footerInner: { maxWidth: 1280, margin: "0 auto", display: "flex", flexDirection: "column", alignItems: "center", gap: 12 },
  footerText: { fontSize: 12, color: "#444", letterSpacing: "0.1em", fontFamily: "'Montserrat', sans-serif", margin: 0 },
};

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;500;700&family=Montserrat:wght@400;600&display=swap');
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { overflow-x: hidden; }
  ::selection { background: rgba(201,169,110,0.3); }
  ::-webkit-scrollbar { width: 6px; }
  ::-webkit-scrollbar-track { background: #080808; }
  ::-webkit-scrollbar-thumb { background: #c9a96e; }
  @keyframes fadeUp { from { opacity:0; transform:translateY(30px); } to { opacity:1; transform:translateY(0); } }
  @keyframes scrollBounce { 0%,100% { transform:translateY(0); opacity:1; } 50% { transform:translateY(8px); opacity:0.4; } }
  @keyframes modalImgFade { from { opacity:0; } to { opacity:1; } }
  .scroll-dot { animation: scrollBounce 1.8s ease-in-out infinite; }
  .fade-in { animation: fadeUp 1s ease 0.2s both; }
  .modal-img-fade { animation: modalImgFade 0.3s ease; }
  .card { transition: transform 0.3s ease, box-shadow 0.3s ease; }
  .card:hover { transform: translateY(-4px); box-shadow: 0 20px 60px rgba(0,0,0,0.5); }
  .form-input:focus { border-bottom-color: #c9a96e !important; }
  button:hover { opacity: 0.85; }
  @media (max-width: 900px) {
    .navLinks { display: none !important; }
    .hamburger { display: flex !important; }
    .aboutGrid { grid-template-columns: 1fr !important; gap: 40px !important; }
    .contactGrid { grid-template-columns: 1fr !important; gap: 40px !important; }
    .modal-inner { grid-template-columns: 1fr !important; }
  }
`;
